(function () {
	'use strict';

	angular.module('qbePortal').directive('qbPromoBox',
		function () {
			return {
				templateUrl: '../ngviews/directives/qbPromoBox.html',				
				restrict: 'E',
			    transclude: true,	
				scope: {
					isConfirmed: '=',
					coreData: '=',
					showThankYou: '=',
					promoData: '='
				},						
				link: function (scope, element, attrs) {					
					scope.clearUserForm = function() {
						scope.$emit('clear-User-Input');
					}
				}
			};
		});

})();

